import React from 'react';
import { Download, Search, HeartPulse } from 'lucide-react';
export function HowItWorksSection() {
  const steps = [{
    icon: <Download className="w-6 h-6 text-noir-text" data-id="element-99" />,
    title: 'Download',
    description: 'Descargas el Expediente en tu celular o lo imprimes en casa.'
  }, {
    icon: <Search className="w-6 h-6 text-noir-text" data-id="element-100" />,
    title: 'Play the Mystery',
    description: 'Eliges un caso y se lo presentas a tu pareja como un reto de detectives. Analizan las pistas y dan su veredicto.'
  }, {
    icon: <HeartPulse className="w-6 h-6 text-noir-text" data-id="element-101" />,
    title: 'Reconnect',
    description: 'Activan la conexión automática. Pasan de silencios incómodos a debates profundos sobre valores y deseos.'
  }];
  return <section className="py-24 bg-noir-bg border-b border-noir-border" data-id="element-102">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl" data-id="element-103">
        <h2 className="text-3xl md:text-4xl font-mono font-bold text-noir-text mb-16 text-center uppercase" data-id="element-104">
          Protocolo de <span className="text-noir-alert" data-id="element-105">Acción</span>
        </h2>

        <div className="relative" data-id="element-106">
          {/* Vertical Line */}
          <div className="absolute left-8 top-4 bottom-4 w-px bg-noir-border" data-id="element-107"></div>

          <div className="space-y-12" data-id="element-108">
            {steps.map((step, index) => <div key={index} className="relative flex items-start" data-id="element-109">
                {/* Square Marker */}
                <div className="absolute left-8 w-3 h-3 bg-noir-alert -translate-x-[5px] translate-y-6 rounded-sm shadow-[0_0_10px_#C8102E]" data-id="element-110"></div>

                <div className="ml-20 bg-noir-card border border-noir-border p-6 rounded-sm w-full relative" data-id="element-111">
                  {/* Step Number Watermark */}
                  <div className="absolute top-2 right-4 text-4xl font-mono font-bold text-noir-bg opacity-50 select-none" data-id="element-112">
                    0{index + 1}
                  </div>

                  <div className="flex items-center space-x-4 mb-3" data-id="element-113">
                    <div className="p-2 bg-noir-bg border border-noir-border rounded-sm" data-id="element-114">
                      {step.icon}
                    </div>
                    <h3 className="text-xl font-mono font-bold text-noir-text uppercase" data-id="element-115">
                      {step.title}
                    </h3>
                  </div>
                  <p className="text-noir-muted pl-14" data-id="element-116">{step.description}</p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}